;(function (window) {
  var Self = window.JMLlocatorData = {}
  var _ = window._
  var $ = window.jQuery
  var settings = {
    eathRadius: 3959
  }
  var state = {
    page: 1,
    perPage: 10,
    isDataLoaded: false,
    fullDataSet: [],
    currentDataSet: [],
    filters: [],
    from: {},
    address: ''
  }

  // TODO - where does this actually belong?
  var products = [
    {
      name: 'Resist Locking Gel',
      id: '29093'
    },
    {
      name: 'Locking Gel',
      id: '29020'
    },
    {
      name: 'Locking Creme Wax',
      id: '29080'
    },
    {
      name: 'Maximum Relief Gro Spray',
      id: '29041'
    },
    {
      name: 'Tingle Shampoo',
      id: '29060'
    },
    {
      name: 'Island Oil',
      id: '29030'
    },
    {
      name: 'Locking Firm Wax',
      id: '29401'
    },
    {
      name: 'No More Itch Gro Spray',
      id: '29040'
    },
    {
      name: 'Jamaican Black Castor Oil - Original',
      id: '02255'
    },
    {
      name: 'Jamaican Black Castor Oil - Coconut',
      id: '02261'
    },
    {
      name: 'Jamaican Black Castor Oil- Rosemary',
      id: '02258'
    },
    {
      name: 'Jamaican Black Castor Oil- Peppermint',
      id: '02295'
    },
    {
      name: 'Jamaican Black Castor Oil - Vitamin A-D-E',
      id: '02296'
    },
    {
      name: 'Jamaican Black Castor Oil - Xtra Dark',
      id: '02256'
    }
  ]

  // private functions

  function init () {
    // TODO - requires https
    // if ('geolocation' in navigator) {
    //   navigator.geolocation.getCurrentPosition(function (position) {
    //     state.from = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude
    //     }
    //   })
    // }

    Self.loadData()
    parseURL()
  }

  function dataLoaded (response) {
    state.fullDataSet = response
    state.currentDataSet = state.fullDataSet
    state.isDataLoaded = true
  }

  function deg2rad (deg) {
    return deg * 0.017453292519943295
  }

  function parseURL () {
    var GET = {}
    var query
    var i = 0
    var l
    var aux

    if (document.location.toString().indexOf('?') !== -1) {
      query = document.location.toString().replace(/^.*?\?/, '').replace(/#.*$/, '').split('&')

      for (i, l = query.length; i < l; i++) {
        aux = decodeURIComponent(query[i]).split('=')
        GET[aux[0]] = aux[1]
      }
    }

    if (!_.isUndefined(GET['locpage'])) {
      state.page = parseInt(GET['locpage'])
    }
  }

  // public functions

  Self.getCoords = function () {
    var address = state.address.replace(' ', '+')

    return $.get(
      'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + window.ajaxSettings.googleAPIKey
    )
  }

  Self.getCurrentPage = function () {
    return Self.getPage(state.page)
  }

  Self.getCurrentPageNum = function () {
    return state.page
  }

  Self.getFilters = function () {
    return state.filters
  }

  Self.getPage = function (pageNum) {
    var last = pageNum * state.perPage
    var first = last - state.perPage

    return state.currentDataSet.slice(first, last)
  }

  Self.getProducts = function () {
    return products
  }

  Self.getSortAddress = function () {
    return state.address
  }

  Self.getSortFrom = function () {
    return state.from
  }

  Self.getTotalPages = function () {
    return Math.ceil(state.currentDataSet.length / state.perPage)
  }

  Self.isDataLoaded = function () {
    return state.isDataLoaded
  }

  // loads the entire data set
  Self.loadData = function () {
    $.get(
      window.ajaxSettings.url,
      {
        action: window.ajaxSettings.dataRequest
      },
      function (response) {
        dataLoaded(response)
      },
      'json'
    )
  }

  // filters state.fullDataSet and then calls Self.sort()
  Self.filter = function () {
    var filters = {}

    _.each(state.filters, function (product) {
      filters[product] = 'true'
    })

    state.currentDataSet = _.where(state.fullDataSet, filters)

    Self.sort()
  }

  Self.setPageNum = function (newNum) {
    state.page = newNum
  }

  Self.setSortAddress = function (address) {
    state.address = address
  }

  Self.setSortFrom = function (from) {
    state.from = from
  }

  // sorts using state.currentDataSet to maintain filters
  Self.sort = function () {
    var tmp = []

    _.each(state.currentDataSet, function (item, i) {
      item.distance = Math.abs(settings.eathRadius * Math.acos(Math.cos(deg2rad(item.lat)) * Math.cos(deg2rad(state.from.lat)) * Math.cos(deg2rad(state.from.lng) - deg2rad(item.lng)) + Math.sin(deg2rad(item.lat)) * Math.sin(deg2rad(state.from.lat))))
      tmp[i] = item
    })

    state.currentDataSet = _.sortBy(tmp, 'distance')
  }

  Self.toggleFilter = function (productID) {
    var index = _.indexOf(state.filters, productID)

    if (index === -1) {
      state.filters.push(productID)
    } else {
      state.filters.splice(index, 1)
    }
  }

  init()
})(window)
